module.exports = __webpack_public_path__ + "media/theme/sample__psn-72572464.png";